/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PolicyStatus;

(function (PolicyStatus) {
  PolicyStatus["POLICY_START"] = "policy_start";
  PolicyStatus["POLICY_UPDATE_INITIATED"] = "policy_update_initiated";
  PolicyStatus["POLICY_UPDATE_QUOTE"] = "policy_update_quote";
  PolicyStatus["POLICY_UPDATE_REFERRAL"] = "policy_update_referral";
  PolicyStatus["POLICY_UPDATE_QUOTE_DELETED"] = "policy_update_quote_deleted";
  PolicyStatus["POLICY_UPDATE_QUOTE_CONFIRMED"] = "policy_update_quote_confirmed";
  PolicyStatus["POLICY_UPDATE_QUOTE_VOID"] = "policy_update_quote_void";
  PolicyStatus["POLICY_PAUSE_PLANNED"] = "policy_pause_planned";
  PolicyStatus["POLICY_PAUSE_INITIATED"] = "policy_pause_initiated";
  PolicyStatus["POLICY_PAUSE_EXTENDED"] = "policy_pause_extended";
  PolicyStatus["POLICY_UNPAUSED"] = "policy_unpaused";
  PolicyStatus["POLICY_RENEW_TRIGGER"] = "policy_renew_trigger";
  PolicyStatus["POLICY_RENEWED_INITIATED"] = "policy_renewed_initiated";
  PolicyStatus["POLICY_RENEWED_UPDATE_SUBMITTED"] = "policy_renewed_update_submitted";
  PolicyStatus["POLICY_RENEWED_UPDATE_REFERRAL"] = "policy_renewed_update_referral";
  PolicyStatus["POLICY_RENEWED_UPDATE_VOID"] = "policy_renewed_update_void";
  PolicyStatus["POLICY_RENEWED_UPDATE_QUOTE"] = "policy_renewed_update_quote";
  PolicyStatus["POLICY_RENEWED"] = "policy_renewed";
  PolicyStatus["RENEWAL_PAYMENT_DELAY_REFERRAL"] = "renewal_payment_delay_referral";
  PolicyStatus["RENEWAL_REFERRAL_APPROVED"] = "renewal_referral_approved";
  PolicyStatus["POLICY_EXTENSION_TRIGGER"] = "policy_extension_trigger";
  PolicyStatus["POLICY_EXTENDED_INITIATED"] = "policy_extended_initiated";
  PolicyStatus["POLICY_EXTENDED"] = "policy_extended";
  PolicyStatus["POLICY_ELAPSED"] = "policy_elapsed";
  PolicyStatus["POLICY_SWITCH_TO_ANNUAL_INITIATED"] = "policy_switch_to_annual_initiated";
  PolicyStatus["POLICY_UPDATED"] = "policy_updated";
  PolicyStatus["POLICY_CANCEL_INITIATED"] = "policy_cancel_initiated";
  PolicyStatus["POLICY_CANCEL_CONFIRMED"] = "policy_cancel_confirmed";
  PolicyStatus["POLICY_CANCELLED"] = "policy_cancelled";
  PolicyStatus["POLICY_PROSPECT"] = "policy_prospect";
  PolicyStatus["POLICY_PROSPECT_INITIATED"] = "policy_prospect_initiated";
  PolicyStatus["POLICY_SWITCHER"] = "policy_switcher";
  PolicyStatus["POLICY_SWITCHER_INITIATED"] = "policy_switcher_initiated";
})(PolicyStatus || (PolicyStatus = {}));